var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.45 20.5002V20.5502H3.5H7.17157C7.84787 20.5502 8.49648 20.2815 8.97469 19.8033L19.9747 8.80331C20.9706 7.80748 20.9706 6.19291 19.9747 5.19706L18.8032 4.02549C17.8073 3.02965 16.1927 3.02965 15.1968 4.02549L4.19688 15.0255C3.71866 15.5037 3.45 16.1523 3.45 16.8286V20.5002ZM15.9747 4.80331C16.5409 4.23705 17.4591 4.23705 18.0253 4.80331L19.1968 5.97488C19.7631 6.54115 19.7631 7.45923 19.1968 8.02549L8.19687 19.0255C7.92495 19.2975 7.55614 19.4502 7.17157 19.4502H4.55V16.8286C4.55 16.444 4.70277 16.0753 4.9747 15.8033L15.9747 4.80331Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6111 10.389L17.6465 10.4243L17.6818 10.389L18.389 9.68184L18.4244 9.64649L18.389 9.61113L14.389 5.61113L14.3537 5.57578L14.3183 5.61113L13.6111 6.31823L13.5758 6.35358L13.6111 6.38894L17.6111 10.389Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit-btn.40d2c93b1872a2d1a68d971aff9cf275.svg";
export { ForwardRef as ReactComponent };